import { useEffect, useState } from 'react';

const DEBOUNCE_MS = 300;

export const useSearchDebounce = (
  searchTerm: string,
  delay: number = DEBOUNCE_MS
): string => {
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

  useEffect(() => {
    if (searchTerm === '') {
      setDebouncedSearchTerm('');
      return;
    }
    const timer = setTimeout(() => setDebouncedSearchTerm(searchTerm), delay);
    return () => clearTimeout(timer);
  }, [searchTerm, delay]);

  return debouncedSearchTerm;
};
